import { omit } from "lodash";
import { apiSlice } from "../services/apiSlice";
import { transformFilters } from "../utils/transformFilters";


export const amsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getLoginUser: builder.query({
            query: () => ({
                url: `/auth/me`,
                method: 'GET',
            }),
        }),

        getFromEmail: builder.query({
            query: () => ({
                url: `/emails/sender-emails`,    
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useGetLoginUserQuery,  
    useGetFromEmailQuery,
} = amsApiSlice;